/** Footer legal pages — admin-editable via Firestore (not the homepage How It Works section). */
export const LEGAL_PAGES = [
  { slug: 'privacy-policy', title: 'Privacy Policy', pageKey: 'privacy-policy', path: '/privacy-policy' },
  { slug: 'terms-of-service', title: 'Terms of Service', pageKey: 'terms', path: '/terms' },
  { slug: 'sec-disclosures', title: 'SEC Disclosures', pageKey: 'sec-disclosures', path: '/sec-disclosures' },
  { slug: 'risk-factors', title: 'Risk Factors', pageKey: 'risk-factors', path: '/risk-factors' },
  { slug: 'investor-agreement', title: 'Investor Agreement', pageKey: 'investor-agreement', path: '/investor-agreement' },
  { slug: 'cookie-policy', title: 'Cookie Policy', pageKey: 'cookie-policy', path: '/cookie-policy' }
];

export const LEGAL_PAGE_BY_KEY = Object.fromEntries(
  LEGAL_PAGES.map((p) => [p.pageKey, p])
);

export const LEGAL_PAGE_KEYS = LEGAL_PAGES.map((p) => p.pageKey);
